$(document).ready(function() {
  // define variables
  var body = $('body'),
      currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      currentHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
      header = body.find('header'),
      pageWrapper = body.find('.page-wrapper'),
      pageWrapperWidth = pageWrapper.width(),
      pageWrapperLeft = pageWrapper.offset().left,
      pageWrapperRight = pageWrapperWidth + pageWrapperLeft,
      headerHeight = header.height(),
      headerBtn = header.find('.btn'),
      headerBtnOffset = 30,
      headerBtnRight = currentWidth - pageWrapperRight,
      lightTheme = false;

  // breakpoints
  var breakpoint = {
    'tiny': 320,
    'phone': 640,
    'tablet': 1024,
    'desktop': 1276,
    'max': 1600
  };

  // set a body class based on the the viewport breakpoint
  setBodyClass();

  // define position 'Get in touch' button
  setContactBtnPos();

  // redefine the body class when the viewport changes size
  $(window).resize(function() {
    // define variables
    currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    currentHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    pageWrapperWidth = pageWrapper.width();
    pageWrapperLeft = pageWrapper.offset().left;
    pageWrapperRight = pageWrapperWidth + pageWrapperLeft;
    headerBtnRight = currentWidth - pageWrapperRight;

    setBodyClass(currentWidth, currentHeight);
    setContactBtnPos();
  });

  // helper function to set the position of the 'Get in touch' button according to the viewport/page wrapper
  function setContactBtnPos () {
    headerBtn.css({
      position: 'fixed',
      right: headerBtnRight + headerBtnOffset,
    });
  }

  // helper function to define body classes based on breakpoints
  function setBodyClass() {
    body.removeClass('tiny phone tablet desktop max full landscape portrait');

    // set a body class based on the viewport breakpoint
    if (currentWidth < breakpoint['tiny']) {
      body.addClass('tiny');
    } else if (currentWidth >= breakpoint['tiny'] && currentWidth < breakpoint['phone']) {
      body.addClass('phone');
    } else if (currentWidth >= breakpoint['phone'] && currentWidth < breakpoint['tablet']) {
      body.addClass('tablet');
    } else if (currentWidth >= breakpoint['tablet'] && currentWidth < breakpoint['desktop']) {
      body.addClass('desktop');
    } else if (currentWidth >= breakpoint['desktop'] && currentWidth < breakpoint['max']) {
      body.addClass('max');
    } else if (currentWidth >= breakpoint['max']) {
      body.addClass('full');
    }

    if (currentWidth < currentHeight) {
      body.addClass('portrait');
    } else {
      body.addClass('landscape');
    }
  }

  // change behaviour 'Get in touch' button on scroll
  $(window).scroll(function(e) {
    var s = $(window).scrollTop();

    if (s > headerHeight - headerBtnOffset) {
      if (headerBtn.hasClass('opaque')) {
        return;
      } else {
        headerBtn.addClass('opaque');
      }

      if (body.hasClass('light')) {
        body.removeClass('light');
        lightTheme = true;
      }
    } else if (s < headerHeight) {
      if (headerBtn.hasClass('opaque')) {
        headerBtn.removeClass('opaque');

        if (lightTheme == true) {
          body.addClass('light');
        }
      }
    }
  });

  // define variable for contact pane on mobile
  var contactPaneOpen = false;

  // show/hide menus in top navigation
  $('.contact-mobile .cta').on('click', function(e) {
    e.preventDefault();

    var $this = $(this),
        contactPane = $this.closest('.contact-mobile');

    if (contactPaneOpen == false) {
      contactPane.addClass('open');
      contactPaneOpen = true;
    } else {
      contactPane.removeClass('open');
      contactPaneOpen = false
    }
  });

  // create page wide slide to anchor from an anchor link
  $('a[href^="#"]:not([href="#"])').click(function(e) {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var $this = $(this),
          target = $(this.hash),
          devices = $this.data('device'),
          orientation = $this.data('orientation');
          deviceMatch = false,
          orientationMatch = false;

      if (typeof(devices) !== 'undefined' && devices !== false) {
        for (var i = 0; i < devices.length; i++) {
          if (bodyClasses.indexOf(devices[i]) !== -1) {
            deviceMatch = true;
          }
        }

        if (deviceMatch == false) {
          return false;
        }
      }

      if (typeof(orientation) !== 'undefined' && orientation !== false && deviceMatch == true) {
        if (bodyClasses.indexOf(orientation) !== -1) {
          orientationMatch = true;
        }

        if (orientationMatch == false) {
          return false;
        }
      }

      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 600);

        return false;
      }
    }

    e.preventDefault();
  });
});

window.submitContactEnquiry = function() {
  $('form#enquiry').submit();
}
